import React, { useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
// import {
//   createBonus,
//   getReportsVariableRevenues,
// } from '../../../lib/fetch/reports';
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../../commons/Auth';
import { useLoading } from '../../../../commons/Loading';
import {
  createBonus,
  createBonusCommercial,
  getReportsVariableRevenuesNetwork,
} from '../../../../lib/fetch/reports';
import VariableRevenuesDetailPresentational from './VariableRevenuesDetailPresentational';
import { useAlert } from 'react-alert';

const VariableRevenuesDetail = (props) => {
  const { profile = {} } = props;

  const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;
  const { _id: profileId } = profile;
  const { showLoading, hideLoading } = useLoading();
  const alert = useAlert();
  const [{ newToken } = {}] = useAuth();
  const [t] = useTranslation('CONTACTS');
  const [reports, setReports] = useState({
    categories: { gnet_admin: {}, supplier: {}, bonuses: { data: [] } },
    totals: {},
  });

  const [total, setTotal] = useState(0);

  const [query, setQuery] = useQueryParams({
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    offset: NumberParam,
    year: withDefault(NumberParam, new Date().getFullYear()),
    accountabilityYear: NumberParam,
    accountabilityMonth: NumberParam,
    dateMonth: NumberParam,
    supplier: withDefault(StringParam, ''),
    number: withDefault(StringParam, ''),
    adminQuery: withDefault(StringParam, ''),
  });

  const {
    limit,
    offset,
    search,
    supplier,
    number,
    adminQuery,
    year,
    accountabilityYear,
    accountabilityMonth,
    dateMonth,
  } = query;

  const [fetchReportsRevenues] = useDebouncedCallback(async () => {
    showLoading();
    const response = await getReportsVariableRevenuesNetwork({
      limit,
      offset,
      profileId,
      year,
      accountabilityYear,
      accountabilityMonth,
      dateMonth,
      newToken,
      supplier,
      number,
      adminQuery,
      search,
    });

    hideLoading();

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    const { data = [] } = response;
    setReports(data);
    setTotal(data.categories?.variableRevenues?.count);
  }, 1000);

  useEffect(() => {
    fetchReportsRevenues();
  }, [
    limit,
    offset,
    search,
    supplier,
    number,
    adminQuery,
    year,
    accountabilityYear,
    accountabilityMonth,
    dateMonth,
  ]);

  function onFilter(queryDiff) {
    if (
      (queryDiff.accountabilityYear &&
        queryDiff.accountabilityYear !== accountabilityYear) ||
      queryDiff.accountabilityYear === ''
    ) {
      queryDiff.accountabilityMonth = '';
      queryDiff.dateMonth = '';
    }

    if (
      (queryDiff.search && queryDiff.search !== search) ||
      (search && queryDiff.search === '') ||
      (queryDiff.supplier && queryDiff.supplier !== supplier) ||
      (supplier && queryDiff.supplier === '') ||
      (queryDiff.number && queryDiff.number !== number) ||
      (number && queryDiff.number === '') ||
      (queryDiff.adminQuery && queryDiff.adminQuery !== adminQuery) ||
      (adminQuery && queryDiff.adminQuery === '') ||
      (queryDiff.year && queryDiff.year !== year) ||
      (year && queryDiff.year === '') ||
      (queryDiff.accountabilityYear &&
        queryDiff.accountabilityYear !== accountabilityYear) ||
      (accountabilityYear && queryDiff.accountabilityYear === '') ||
      (queryDiff.limit && queryDiff.limit !== limit)
    ) {
      queryDiff.offset = 0;
    }
    setQuery(queryDiff);
  }

  async function onAddCommercialBonus(bonus) {
    if (!(Number(bonus?.amount) > 0)) {
      alert.error(t('COMMON:ERROR_TOTAL_TO_INVOICE_0'));
      return;
    }

    const { error } = await createBonusCommercial({
      newToken,
      bonus: { ...bonus, profileId },
      year,
    });

    if (error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    fetchReportsRevenues();
    alert.success(t('COMMON:SUCCESS_CREATE'));
  }

  return (
    <VariableRevenuesDetailPresentational
      data={reports}
      onAddCommercialBonus={onAddCommercialBonus}
      onFilter={onFilter}
      query={query}
      total={total}
      profileType={profile.type}
      {...props}
    />
  );
};

export default VariableRevenuesDetail;
